import React, { useState, useEffect, useContext } from 'react';
import { Column } from 'react-table';
import { KTIcon } from '../../../_myb/helpers/components/KTIcon';
import { DataTable } from '../widgets/components/DataTable';
import { Content } from '../../../_myb/layout/components/content';
import { fetchAccounts } from '../../api';
import { Currency } from '../../types';
import { ToolbarContext } from '../../../_myb/layout/components/toolbar/Toolbar';
import CustomModal from '../widgets/components/CustomModal';
import Picker from '../widgets/components/SimplePicker';
import { OptionType } from '../masterdata/components/AttributePicker';
import { currencyData } from '../../DS-Files';



  interface CurrencyPickerProp{
    label?:string;
    selectedCurrency?:string;
    onSelectionChange: (currId: string) => void;
  }

  export const transformCurrencyData = () => {
    return currencyData.map((currency) => {
      // Extract the currencyId (first 3 characters of the currency_code)
      const currencyId = currency.currency_code.slice(0, 3);
      
      // Extract the currency name (everything after the first hyphen in currency_code)
      const currencyName = currency.currency_code.split('-')[1];
  
      return {
        currencyId,          // 3-character identifier
        currencySymbol: currency.currency_symbol,  // Currency symbol
        currencyName         // Currency name
      };
    });
  };

  export const CurrencyPicker: React.FC<CurrencyPickerProp> = ({label,selectedCurrency,onSelectionChange}) => {
    

      const currencyInfo = transformCurrencyData()
      const currencyOptions : OptionType[] = currencyInfo.map(currency => ({
        value: currency.currencyId,
        label: `${currency.currencyId} - ${currency.currencyName}`,
      }));

      const handleSelectionChange = (selectedOption: OptionType | null) => {
        if (selectedOption){
          onSelectionChange(selectedOption.value)
        }
      };
    return (
      <Picker label={label} value={selectedCurrency} onSelectionChange={handleSelectionChange}  options={currencyOptions} placeholder={'Select Currency'.toTranslatedDisplay()} />
    )
  
    
  }

  
  export const CurrencyManagement: React.FC = () => {
    const [currencies, setCurrencies] = useState<Currency[]>([]);


    
    const { updateToolbar } = useContext(ToolbarContext);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const handleModalClose = () => {
        setIsModalOpen(false);
      };
    
    
    const updateButtons = () => {
      updateToolbar({
        primaryButton: {
          enabled: true,
          text: 'Add Currency',
          icon: 'create', // Replace with appropriate icon type
          action: async () => {
            setIsModalOpen(true);
          }
        },
        secondaryButton: {
          enabled: true,
          text: 'Secondary',
          icon: 'secondary-icon', // Replace with appropriate icon type
          action: async () => {
          }
        }
      });
    };
  
    
    useEffect(() => {
      updateButtons();
    }, []);

    
  
    const columns: Column<Currency>[] = React.useMemo(
      () => [
        {
          Header: 'Currency ID'.toTranslatedDisplay(),
          accessor: 'currId',
          width: '20%',
          ClassName: ''
        },
        {
          Header: 'Currency Name'.toTranslatedDisplay(),
          accessor: 'currName',
          width: '40%',
          ClassName: ''
        },
        {
          Header: 'Currency Symbol'.toTranslatedDisplay(),
          accessor: 'currSymbol',
          width: '20%',
          ClassName: ''
        },
        {
          Header: 'Actions'.toTranslatedDisplay(),
          disableSortBy: true,
          width: '20%',
          ClassName: 'text-center',
          Cell: ({ row }: { row: { original: Currency } }) => (
            <div>
              <button className="btn btn-sm btn-light p-2 m-1" data-bs-toggle="tooltip" data-bs-placement="top" title={'Edit'.toTranslatedDisplay()}>
                <KTIcon className="fs-3 text-hover-primary text-muted" iconType='solid' iconName='pencil' />
              </button>
              <button className="btn btn-sm btn-light p-2 m-1" data-bs-toggle="tooltip" data-bs-placement="top" title={'Delete'.toTranslatedDisplay()}>
                <KTIcon className="fs-3 text-muted text-hover-danger" iconName='trash' />
              </button>
            </div>
          ),
        },
      ],
      []
    );
    const handleSelectChange = (currId:string) => {

    }
    return (
      <Content>
        <DataTable columns={columns} data={currencies}
          emptyStateActions={[
            { label: 'Add Currency'.toTranslatedDisplay(), onClick: () => setIsModalOpen(true) },
          ]} />
        <CustomModal
        title={'Add Currency'.toTranslatedDisplay()}
        isVisible={isModalOpen}
        onClose={handleModalClose}
        body={<CurrencyPicker onSelectionChange={handleSelectChange} />} id={""} onSave={function (): void {
          throw new Error("Function not implemented.");
        } }      />
      </Content>
    );
  };
  
 


  export default CurrencyManagement;